<template>
  <base-card :projectID="projectID" :categoryID="categoryID" :storyType="storyType" :isMarginless="isMarginless" :isRowLoading="isRowLoading" :isPinnableRow="isPinnableRow" :pinnedProjects="pinnedProjects" :disableLink="disableLink">
    <information :isRowLoading="isRowLoading" :isBlank="isBlank">
      <resource-type :project="project"></resource-type>
    </information>
    <project-title :isRowLoading="isRowLoading" :isBlank="isBlank" :title="title" :elementID="elementID" :customLineClamp="3" />
    <project-image :image="image" :isRowLoading="isRowLoading" :imageBackground="imageBackground" :isBlank="isBlank" :isVisible="isVisible" :imageOverlay="imageOverlay"/>
  </base-card>
</template>

<script>
import BaseCard from './BaseCard'
import base from '../mixins/base'
import visibility from '@/mixins/visibility'
import ProjectTitle from '../UI/Title'
import Information from '../UI/Information'
import ProjectImage from '../UI/ProjectImage'
import ResourceType from '../UI/ResourceType'
import User from '../UI/User'
export default {
  name: 'Article',
  components: {
    BaseCard,
    ProjectTitle,
    Information,
    ProjectImage,
    User,
    ResourceType
  },
  props: {
    projectID: Number,
    categoryID: Number,
    storyType: Boolean,
    isMarginless: [Boolean, String],
    isRowLoading: Boolean,
    isPinnableRow: Boolean,
    pinnedProjects: Array,
    disableLink: Boolean
  },
  mixins: [base, visibility]
}
</script>

<style lang="scss" scoped>
  @import '~styles/utils.scss';
  ::v-deep .main-container .story-title {
    min-height: 69.95px;
    margin-top: 0;
    @include mobile {
    min-height: 62.95px;
    }
  }
</style>
